export function renderEmailHtml({ template, summaryData, contact }) {
  const {
    totalCost,
    savings,
    serviceType,
    priceDetails,
    isHomme,
    details,
  } = summaryData || {};

  const formatNumber = (num) => {
    return typeof num === 'number'
      ? num.toFixed(2).replace('.', ',')
      : typeof num === 'string'
        ? num.replace('.', ',')
        : '0,00';
  };

  let html = template || '';

  const simulatorUrl = 'https://www.addict-paris.fr/simulateur/';
  html = html.replaceAll('##EMAIL_SIMULATOR_URL##', simulatorUrl);

  /* Header personnalisé (homme / femme) */
  if (isHomme) {
    html = html.replaceAll(
      '##EMAIL_HEADER_IMAGE##',
      'https://www.addict-paris.fr/simulateur/email/email-homme-v2.png'
    );
    html = html.replaceAll(
      '##EMAIL_HEADER_IMAGE_ALT##',
      'Addict Paris - Votre simulation (Homme)'
    );
  } else {
    html = html.replaceAll(
      '##EMAIL_HEADER_IMAGE##',
      'https://www.addict-paris.fr/simulateur/email/email-femme-v2.png'
    );
    html = html.replaceAll(
      '##EMAIL_HEADER_IMAGE_ALT##',
      'Addict Paris - Votre simulation (Femme)'
    );
  }

  const prenom = contact?.prenom || '';
  const nom = contact?.nom || '';
  const resolvePrestationLabel = () => {
    if (isHomme) {
      const labels = (Array.isArray(priceDetails) ? priceDetails : [])
        .map((d) => (d?.label ? String(d.label).toLowerCase() : ''))
        .filter(Boolean);
      const hasBarbe = labels.some((l) => l.includes('barbe'));
      const hasCoupe = labels.some(
        (l) => l.includes('coupe') || l.includes('dégradé') || l.includes('degrad')
      );

      if (hasBarbe && hasCoupe) return 'Cheveux et barbe';
      if (hasBarbe) return 'Barbe';
      if (hasCoupe) return 'Cheveux';
      return (serviceType || 'Prestation').toString().trim();
    }

    const femmeType = details?.mainService?.type
      ? String(details.mainService.type).toLowerCase()
      : '';
    switch (femmeType) {
      case 'brushing':
        return 'Brushing (Shampoing + Brushing)';
      case 'gloss':
        return 'Gloss (Shampoing + Patine + Brushing)';
      case 'coloration': {
        const isPremium = Boolean(details?.premium?.selected);
        return `Coloration (Shampoing + Coloration ${isPremium ? 'premium' : 'classique'} + Brushing)`;
      }
      default:
        return (serviceType || 'Prestation').toString().trim();
    }
  };

  const prestationLabel = resolvePrestationLabel();
  const safeServiceType = (serviceType || 'personnalisé').toString().trim();
  const monthly = Number.parseFloat(totalCost || '0') || 0;
  const saving = Number.parseFloat(savings || '0') || 0;
  const withoutSubscriptionMonthly = Math.max(monthly + saving, 0);

  const resolvePrestationIcon = () => {
    if (isHomme) {
      const labels = (Array.isArray(priceDetails) ? priceDetails : [])
        .map((d) => (d?.label ? String(d.label).toLowerCase() : ''))
        .filter(Boolean);
      const hasBarbe = labels.some((l) => l.includes('barbe'));
      const hasCoupe = labels.some(
        (l) => l.includes('coupe') || l.includes('dégradé') || l.includes('degrad')
      );

      if (hasBarbe && hasCoupe) {
        return {
          src: 'https://www.addict-paris.fr/simulateur/email/coupehomme.png',
          alt: 'Cheveux et barbe',
        };
      }
      if (hasBarbe) {
        return {
          src: 'https://www.addict-paris.fr/simulateur/email/soinbarbe.png',
          alt: 'Barbe',
        };
      }
      if (hasCoupe) {
        return {
          src: 'https://www.addict-paris.fr/simulateur/email/coupehomme.png',
          alt: 'Cheveux',
        };
      }
      return { src: 'https://www.addict-paris.fr/simulateur/email/euros.png', alt: 'Prestation' };
    }

    const femmeType = details?.mainService?.type
      ? String(details.mainService.type).toLowerCase()
      : '';
    switch (femmeType) {
      case 'brushing':
        return { src: 'https://www.addict-paris.fr/simulateur/email/brushing.png', alt: 'Brushing' };
      case 'gloss':
        return { src: 'https://www.addict-paris.fr/simulateur/email/gloss.png', alt: 'Gloss' };
      case 'coloration':
        return { src: 'https://www.addict-paris.fr/simulateur/email/couleur.png', alt: 'Coloration' };
      default:
        return { src: 'https://www.addict-paris.fr/simulateur/email/euros.png', alt: 'Prestation' };
    }
  };

  const prestationIcon = resolvePrestationIcon();

  const resolveIntroTarget = () => {
    if (isHomme) {
      const labels = (Array.isArray(priceDetails) ? priceDetails : [])
        .map((d) => (d?.label ? String(d.label).toLowerCase() : ''))
        .filter(Boolean);
      const hasBarbe = labels.some((l) => l.includes('barbe'));
      const hasCoupe = labels.some(
        (l) => l.includes('coupe') || l.includes('dégradé') || l.includes('degrad')
      );

      if (hasBarbe && hasCoupe) return 'votre barbe et vos cheveux';
      if (hasBarbe) return 'votre barbe';
      if (hasCoupe) return 'vos cheveux';
      return 'votre look';
    }

    const femmeType = details?.mainService?.type
      ? String(details.mainService.type).toLowerCase()
      : '';
    switch (femmeType) {
      case 'coloration':
        return 'votre couleur';
      case 'brushing':
        return 'votre brushing';
      case 'gloss':
        return 'votre gloss';
      default:
        return 'votre look';
    }
  };

  const introTarget = resolveIntroTarget();

  const resolveFrequencyLine = () => {
    const fmt = (n) => `${n} fois / mois`;

    if (isHomme) {
      const labels = (Array.isArray(priceDetails) ? priceDetails : [])
        .map((d) => (d?.label ? String(d.label) : ''))
        .filter(Boolean);

      const parseX = (label) => {
        const m = label.match(/\(x(\d+)\)/i);
        const n = m ? Number.parseInt(m[1], 10) : 1;
        return Number.isFinite(n) && n > 0 ? n : 1;
      };

      const coupeLabel = labels.find((l) => /coupe|dégradé|degrad/i.test(l));
      const barbeLabel = labels.find((l) => /barbe/i.test(l));
      const coupeFreq = coupeLabel ? parseX(coupeLabel) : null;
      const barbeFreq = barbeLabel ? parseX(barbeLabel) : null;

      if (coupeFreq && barbeFreq) {
        if (coupeFreq === barbeFreq) return `Fréquence : ${fmt(coupeFreq)}`;
        return `Cheveux ${fmt(coupeFreq)} • Barbe ${fmt(barbeFreq)}`;
      }
      if (coupeFreq) return `${fmt(coupeFreq)}`;
      if (barbeFreq) return `${fmt(barbeFreq)}`;
      return '1 fois / mois';
    }

    const freq = summaryData?.details?.mainService?.frequency
      ? Number.parseInt(summaryData.details.mainService.frequency, 10)
      : Number.parseInt(summaryData?.frequency, 10);
    const safeFreq = Number.isFinite(freq) && freq > 0 ? freq : 1;
    return `${fmt(safeFreq)}`;
  };

  const frequencyLine = resolveFrequencyLine();

  const introHtml = `
    <div style="text-align:center;">
      <p style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 16px; line-height:1.6; margin:0;font-weight:700;">
        Bonjour ${[prenom, nom].filter(Boolean).join(' ')},
      </p>
      <p style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 16px; line-height:1.6; margin:0;">
        Merci pour votre simulation !
      </p>
      <div style="height:10px;line-height:10px;font-size:10px;">&nbsp;</div>
      <p style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 16px; line-height:1.6; margin:0;">
        Voici votre abonnement personnalisé, pour un<br>
        entretien parfait de ${introTarget}, tous les mois.
      </p>
    </div>
  `.trim();
  html = html.replace('##EMAIL_INTRO##', introHtml);

  const stripX1 = (s) =>
    s.replace(/\s*\(x1\)\s*/gi, '').replace(/\s{2,}/g, ' ').trim();

  const isBaseServiceLine = (rawLabel) => {
    const label = String(rawLabel || '').toLowerCase();

    if (isHomme) {
      // Les lignes "base" homme sont coupe / barbe (déjà expliquées au-dessus)
      if (/(coupe|dégradé|degrad)/i.test(label)) return true;
      if (/barbe/i.test(label)) return true;
      return false;
    }

    const femmeType = details?.mainService?.type
      ? String(details.mainService.type).toLowerCase()
      : '';

    // Brushings supplémentaires = options (on garde)
    if (label.includes('suppl') && label.includes('brushing')) return false;

    if (femmeType === 'brushing') {
      // Base brushing
      return label.includes('brushing') && !label.includes('suppl');
    }
    if (femmeType === 'gloss') {
      // Base gloss
      return label.includes('gloss');
    }
    if (femmeType === 'coloration') {
      // Base coloration: "forfait coloration ..."
      return label.includes('coloration') && label.includes('forfait');
    }

    return false;
  };

  const optionsLines = (Array.isArray(priceDetails) ? priceDetails : [])
    .filter((d) => d?.label && !isBaseServiceLine(d.label))
    .slice(0, 4)
    .map((d) => `• ${stripX1(String(d.label).replace(/^le\s+/i, ''))}`)
    .filter(Boolean);

  const optionsHtml = optionsLines.length
    ? `<div style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 12px; line-height:1.5; color:#000000;padding-left:20px;">${optionsLines
        .map((t) => `<div style="margin:0;">${t}</div>`)
        .join('')}</div>`
    : '';

  const optionsSectionHtml = optionsLines.length
    ? `
      <p style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 12px; line-height:1.4; margin:4px 0 0 0; color:#444444;">
        <img src="https://www.addict-paris.fr/simulateur/email/options.png" alt="Options" style="width:16px;height:16px;vertical-align:middle;margin-right:4px;" /> Options :
      </p>
      ${optionsHtml}
    `.trim()
    : '';

  const subscriptionBoxHtml = `
    <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;">
      <tr>
        <td align="center">
          <table role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-collapse:separate;border-spacing:0;background:#F8F5EF;border:1px solid #D6C08A;border-radius:8px;max-width:620px;width:100%;">
            <tr>
              <td style="padding:16px 16px 10px 16px;text-align:center;">
                <p style="font-family: Roboto, Tahoma, sans-serif; font-size: 18px; line-height:1.2; margin:0; color:#000000; font-weight:700;">
                  Votre abonnement <span style="color:#9B885C;font-weight:700;">${safeServiceType}</span><sup>*</sup>
                </p>
              </td>
            </tr>
            <tr>
              <td style="padding:0 16px 16px 16px;">
                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;">
                  <tr>
                    <td valign="top" style="width:62%;padding-right:10px;">
                      <p style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 16px; line-height:1.3; margin:0; color:#000000;">
                        <img src="https://www.addict-paris.fr/simulateur/email/euros.png" alt="Prix" style="width:16px;height:16px;vertical-align:middle;margin-right:4px;" /> <span style="color:#9B885C;font-weight:700;">${formatNumber(monthly)} €</span> / mois
                      </p>
                      <p style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 13px; line-height:1.4; margin:6px 0 0 0; color:#000000;">
                        <img src="${prestationIcon.src}" alt="${prestationIcon.alt}" style="width:16px;height:16px;vertical-align:middle;margin-right:4px;" /> ${prestationLabel}
                      </p>
                      <p style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 12px; line-height:1.4; margin:4px 0 0 0; color:#444444;">
                        <img src="https://www.addict-paris.fr/simulateur/email/calendar.png" alt="Frequence" style="width:16px;height:16px;vertical-align:middle;margin-right:4px;" />  ${frequencyLine}
                      </p>
                      
                      <div style="height:8px;line-height:8px;font-size:8px;">&nbsp;</div>

                      ${optionsSectionHtml}
                      
                    </td>
                    <td valign="top" style="width:38%;padding-left:10px;">
                      <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:separate;border-spacing:0;background:#E6D8B4;border:1px solid #D6C08A;border-radius:8px;">
                        <tr>
                          <td style="padding:10px 10px;">
                            <p style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 12px; line-height:1.4; margin:0; color:#000000;text-align:center;">
                              <strong>Sans abonnement :</strong><br>
                              <span style="color:#000000;font-weight:700;">${formatNumber(withoutSubscriptionMonthly)}€</span> / passage
                            </p>
                            <div style="height:8px;line-height:8px;font-size:8px;">&nbsp;</div>
                            <hr style="border:0;border-top:1px solid #D6C08A;margin:8px 0;" />
                            <div style="height:8px;line-height:8px;font-size:8px;">&nbsp;</div>
                            <p style="font-family: Ubuntu, Helvetica, Arial, sans-serif; font-size: 12px; line-height:1.4; margin:0; color:#000000;text-align:center;">
                              <strong>Économie :</strong><br>
                              <span style="color:#000000;font-weight:700;">${formatNumber(saving)}€</span> / mois
                            </p>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  `.trim();
  html = html.replace('##EMAIL_SUBSCRIPTION_BOX##', subscriptionBoxHtml);

  return html;
}

